/**
 * User: Rob Richard
 * Date: 5/16/14
 * Time: 1:58 PM
 */

'use strict';

var _ = require('underscore');
var SoaModel = require('bunsen/models/SoaModel.js');
var Backbone = require('dibs-backbone');

/**
 * @class Party
 * @extends SoaModel
 */
var Party = SoaModel.extend(/** @lends Party.prototype */{
    relations: [{
        type: Backbone.One,
        relatedModel: SoaModel,
        key: 'entity'
    }],
    getRole: function () {
        return this.get('role');
    },
    isRole: function (role) {
        return this.get('role') === role;
    }
});

Party.prototype.isInternal = Party.prototype.is1stdibs = function () {
    return this.isRole(Party.ROLE_INTERNAL);
};
Party.prototype.isLSP = Party.prototype.isShipper = function () {
    return this.isRole(Party.ROLE_LSP);
};
Party.prototype.isDealer = Party.prototype.isSeller = function () {
    return this.isRole(Party.ROLE_SELLER);
};
Party.prototype.isBuyer = Party.prototype.isCustomer = function () {
    return this.isRole(Party.ROLE_BUYER);
};

_.extend(Party, /** @lends Party */{
    ROLE_INTERNAL: 'INTERNAL',
    ROLE_LSP: 'LSP',
    ROLE_BUYER: 'BUYER',
    ROLE_SELLER: 'SELLER'
});

module.exports = Party;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Party.js
// module id = 8
// module chunks = 62